import 'core-js'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'
import App from './App'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
